import { Controller } from "@hotwired/stimulus"

// AT-1110: laten zien dat er iets gebeurt na een klik.
//
// De datumtegels, de datumrijen op het detail en de knoppen op de agendakaart zijn
// gewone links: een klik levert een volledige paginalading op en tot die klaar is
// gebeurt er zichtbaar niets. Op een trage verbinding klikt een bezoeker dan nog eens.
//
// Bewust gedelegeerd vanaf één punt in de layout in plaats van een controller per
// element: het gaat om elk element dat wegnavigeert, en dat zijn er veel verspreid over
// alle schermen. Zo hoeft geen enkele view er iets voor te doen.
export default class extends Controller {
  // Elke knopvorm, niet een opsomming van plekken. Die opsomming liep steeds achter:
  // eerst miste de knop in een leeg winkelmandje, daarna die in de kop. Wat níet
  // wegnavigeert wordt hieronder uitgesloten, en dat is een korte lijst die wél te
  // overzien is.
  static SELECTOR = ".btn, .date-tile, .date-row, .site-header__actions a"

  connect() {
    // Terug via de knop van de browser haalt de pagina uit de bfcache: hij komt terug
    // precies zoals hij was, dus met de rondjes nog draaiend op de knop die je indrukte.
    // Er gebeurt dan niets meer, maar het ziet eruit alsof de shop hangt.
    //
    // pageshow vuurt zowel bij een gewone lading als bij een herstel uit de cache; alleen
    // bij dat laatste staat persisted op true. We ruimen bij allebei op -- een verse
    // pagina heeft niets te wissen, dus het kost niets en dekt ook een terugnavigatie die
    // de cache misliep.
    this.opruimen = () => this.#clear()
    window.addEventListener("pageshow", this.opruimen)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.opruimen)
  }

  #clear() {
    this.element.querySelectorAll(".is-busy").forEach((el) => {
      el.classList.remove("is-busy")
      el.removeAttribute("aria-busy")
    })
  }

  start(event) {
    const el = event.target.closest(this.constructor.SELECTOR)
    if (!el) return

    // Niets doen bij wat niet wegnavigeert: uitgegrijsde plaatsvervangers, ankers,
    // modals (inloggen, wachtlijst) en alles wat de bezoeker in een nieuw tabblad opent.
    if (el.matches(".date-tile--disabled, .date-row--disabled, .btn--disabled")) return
    if (el.dataset.toggle || el.target === "_blank") return
    if (el.tagName === "A" && (el.getAttribute("href") || "").startsWith("#")) return
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return

    // En niets doen als de knop zijn eigen laadbeeld meebrengt, anders draaien er twee
    // rondjes tegelijk. De views die nog niet gemigreerd zijn -- het zaalplan, de
    // donatie -- zetten via rails-ujs een Bootstrap-spinner in de knop; die staat als
    // markup in data-disable-with. De red2-views zetten daar alleen een tekst neer, en
    // meestal dezelfde tekst als het label, dus daar is ons rondje juist het enige
    // teken dat er iets gebeurt. Het verschil is dus: brengt het label markup mee.
    if ((el.dataset.disableWith || "").includes("<")) return

    el.classList.add("is-busy")
    el.setAttribute("aria-busy", "true")
  }
}
